var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "page-columns",
      class: {
        bordered: _vm.bordered,
        reverse: _vm.reverse,
        column_full: _vm.column_full,
        column_half: _vm.column_half
      }
    },
    [
      _c("div", { staticClass: "column column-first" }, [
        _c("div", { staticClass: "column-inner" }, [_vm._t("first")], 2)
      ]),
      _c("div", { staticClass: "column column-last" }, [
        _c("div", { staticClass: "column-inner" }, [_vm._t("last")], 2)
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78c701ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78c701ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/PageColumns.vue
// module id = o75A
// module chunks = 41